import { action, observable } from 'mobx';
import { InputChangeEvent } from 'ui/base/types';

export class PasswordStore {
  @observable.ref
  value: string;

  @observable.ref
  visible: boolean;

  constructor(value: string, visible = false) {
    this.value = value;
    this.visible = visible;
  }

  @action.bound
  onChange(event: InputChangeEvent) {
    this.value = event.target.value;
  }

  @action.bound
  toggleVisible() {
    this.visible = !this.visible;
  }
}
